import React, { Component } from "react";
import "./ProductLibrary.css";

import General from "../../../../utils/General";
import SearchBar from "../../../../components/product-library/SearchBar";

import ProductLibrarySectionTable from "../../tables/product-library/ProductLibrarySectionTable";

export default class ProductLibrarySection extends Component {
  constructor(props) {
    super(props);

    this.debounceTimeout = null;

    const selectedCategoryItem = this._resolveSelectedCategory(props);

    this.state = {
      selectedCategoryItem,
      searchQuery: "",
      debouncedSearchQuery: "",
      isSearching: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      const selectedCategoryItem = this._resolveSelectedCategory(
        this.props,
        this.state.selectedCategoryItem
      );

      if (selectedCategoryItem !== this.state.selectedCategoryItem) {
        this.setState({ selectedCategoryItem });
      }
    }

    if (prevState.searchQuery !== this.state.searchQuery) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        this.setState({
          debouncedSearchQuery: this.state.searchQuery.trim(),
        });
      }, 300);
    }
  }

  componentWillUnmount() {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  }

  _resolveSelectedCategory(props = this.props, currentSelection = null) {
    if (!props.data || props.data.length === 0) {
      return null;
    }

    if (currentSelection) {
      const stillExists = props.data.find(
        (category) => category?.id == currentSelection
      );

      if (stillExists) {
        return currentSelection;
      }
    }

    return props.data[0].id;
  }

  // 🔹 CHANGED: tab click now also resets search (optional but better UX)
  onClickTabItem = (tabId) => {
    this.setState({
      selectedCategoryItem: tabId,
      searchQuery: "",
      debouncedSearchQuery: "",
      isSearching: false,
    });
  };

  _showCategories() {
    const { selectedCategoryItem } = this.state;

    return this.props.data?.map((categoryItem) => (
      <li className="nav-item mt-3" key={categoryItem?.id}>
        <button
          type="button"
          onClick={() => {
            this.onClickTabItem(categoryItem?.id);
          }}
          className={`nav-link ${
            selectedCategoryItem === categoryItem?.id ? "active" : ""
          }`}
          // accessibility
          aria-pressed={selectedCategoryItem === categoryItem?.id}
        >
          <span className="nav-text">
            {General.toTitleCase(categoryItem?.title)}
          </span>
        </button>
      </li>
    ));
  }

  _handleSearchChange = (value) => {
    this.setState({ searchQuery: value });
  };

  _handleTableLoading = (isLoading) => {
    const hasSearch =
      (this.state.searchQuery && this.state.searchQuery.trim().length > 0) ||
      (this.state.debouncedSearchQuery &&
        this.state.debouncedSearchQuery.trim().length > 0);

    this.setState({ isSearching: hasSearch ? isLoading : false });
  };

  render() {
    const {
      selectedCategoryItem,
      searchQuery,
      debouncedSearchQuery,
      isSearching,
    } = this.state;

    const category = this.props?.data?.find(
      (item) => item?.id == selectedCategoryItem
    );

    const categoryId = category?.id;

    return (
      <div className="wizard-body py-8 px-10 py-lg-20 px-lg-10">
        {/* Search */}
        <div className="mb-6" style={{ maxWidth: 700 }}>
          <SearchBar
            value={searchQuery}
            onChange={this._handleSearchChange}
            isLoading={isSearching}
          />
        </div>

        {/* Category pills */}
        <div className="row">
          <div className="col-12">
            <div className="form-group category-row">
              <ul
                className="nav nav-primary nav-pills flex-wrap"
                id="category-tabs"
                role="tablist"
              >
                {this._showCategories()}
              </ul>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="col-12 p-0">
          <ProductLibrarySectionTable
            categoryId={categoryId}
            searchTerm={debouncedSearchQuery}
            onLoadingChange={this._handleTableLoading}
            noDataMessage={
              debouncedSearchQuery ? "No results found" : "No items found"
            }
          />
        </div>
      </div>
    );
  }
}
